<!--家长签到-->
<template>

  <div class="root-container">

    <!--    查询结果区域-->
    <div class="search-result-area">

      <!--      表单结果-->
      <el-table
        :data="tableData"
        height="500"
        border
        style="width: 100%"
       >

        <el-table-column type="selection" width="55"></el-table-column>
        <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
        <el-table-column prop="date" label="时间" width="180"></el-table-column>
        <el-table-column prop="LogType" label="类型" width="180"></el-table-column>
        <el-table-column prop="buyCardId" label="家长卡号"></el-table-column>
        <el-table-column prop="totalLessons" label="总课时"></el-table-column>
        <el-table-column prop="remainingClass" label="剩余课时"></el-table-column>


      </el-table>

    </div>
  </div>
</template>

<style>
  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .search-result-area{
    width: 100%;
    margin-top: 50px;
    /*设置边框颜色和圆角*/
    border-top: 2px solid rgb(227,227,227);
    border-bottom: 1px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
  }
</style>

<script>

  export default {
    name: 'UserSingInLog',
    props: {
      title: {
        msg: ''
      },
      detail :{
        type : Array,
        required:true,
      },
    },
    data() {
      return {
        tableData:[]
      }
    },
    created(){
      this.refreshData();
    },
    mounted() {

    },
    methods: {
      refreshData(){
        this.tableData = [];

        for (let i  = 0;i<this.detail.length;++i){
          let date = this.detail[i].time;
          let list = this.detail[i].content ;
          let LogType = this.detail[i].LogType;

          let data = {
            number:i+1,
            date:date,
            LogType:LogType,
            buyCardId:list[0],
            totalLessons:list[1],
            remainingClass:list[2],
          }

          this.tableData.push(data);
        }

      }


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/log/components/UserSingInLog.vue